<template>
  <div class="aside-box">
    <div class="floor-name">
      <div class="info-name">
        <span style="opacity: 0">*</span>
        <p>楼层名称</p>
      </div>
      <div class="info-content">
        <el-input
          v-model.trim="info.name"
          placeholder="请输入楼层名称"
          maxlength="6"
          show-word-limit
          class="floor-name-input"
          @input="updateVuex()"
        ></el-input>
      </div>
    </div>
    <div class="box-body">
      <div class="info-name">
        <span style="opacity: 0">*</span>
        <p>内容</p>
      </div>
      <div class="info-content nav-info-content">
        <ul class="nav-list" id="nav-list">
          <li
            class="nav-li"
            v-for="(item3, index3) in info.contentList"
            :key="index3"
          >
            <div class="nav-header">
              <p>导航{{ index3 + 1 }}</p>
              <div class="del-nav-icon" @click="delNav(index3)"></div>
            </div>
            <div class="nav-body">
              <div class="nav-name">
                <span>*</span>
                <p>名称</p>
                <el-input
                  v-model="item3.navName"
                  placeholder="建议输入4个字以内"
                  maxlength="4"
                  show-word-limit
                  class="nav-name-input"
                  @input="updateVuex()"
                ></el-input>
              </div>
              <div class="nav-img">
                <span>*</span>
                <p>图片</p>
                <div
                  v-if="item3.navImg.length"
                  class="nav-img-box"
                  :style="'background-image: url(' + item3.navImg + ')'"
                >
                  <div class="del-img-box">
                    <div class="del-img-icon" @click="delNavImg(index3)"></div>
                  </div>
                </div>
                <div v-else class="add-img-box" @click="navImgClick(index3)">
                  +
                </div>
                <div class="nav-img-tips">
                  尺寸为40px*40px，支持JPG、PNG，大小不超过10KB
                </div>
              </div>
              <div class="nav-url">
                <p>跳转链接</p>
                <el-select
                  v-model="item3.linkType"
                  clearable
                  class="nav-url-input"
                  placeholder="请选择跳转的页面"
                  @visible-change="visibleHandler(item3.linkType, index3)"
                  @clear="clearHandler(index3)"
                >
                  <el-option
                    v-for="(item4, index4) in options"
                    :key="index4"
                    :label="item4.label"
                    :value="item4.value"
                  >
                  </el-option>
                </el-select>
                <!-- <el-input
                  v-model="item3.navUrl"
                  placeholder="输入链接"
                  show-word-limit
                  class="nav-url-input"
                  @blur="blurNavUrl(index3)"
                ></el-input> -->
              </div>
            </div>
          </li>
        </ul>
        <input
          type="file"
          ref="navImg"
          accept="image/png,image/jpeg"
          style="display: none"
          @change="selectNavImg()"
        />
        <div class="add-content-li" @click="addNavContent()">
          <span>+</span>
          <p>添加导航</p>
          <div>（{{ info.contentList.length }}/{{ info.maxCount }}）</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
  name: "ShopCenterAdminWebMAsideNav",
  props: {
    floor: {
      type: Object,
    },
  },
  data() {
    return {
      info: {
        id: 206,
        name: "快捷导航",
        count: 1, // 展示数量
        maxCount: 8, // 最大展示数量
        contentList: [
          {
            navName: "",
            navImg: "",
            link: "",
            linkType: "",
          },
        ], // 楼层内容列表 默认一个
      },
      options: [
        {
          label: "内容",
          value: 1,
        },
        {
          label: "导航",
          value: 2,
        },
      ],
    };
  },
  watch: {
    "floor.index": {
      handler() {
        // 获取快捷导航楼层数据
        this.info = JSON.parse(
          JSON.stringify(
            this.$store.state.mDecoration.floorList[this.floor.index]
          )
        );
        // 开启拖拽功能
        this.$nextTick(() => {
          // 开启拖拽排序
          var el = document.getElementById("nav-list");
          new Sortable(el, {
            animation: 150,
            filter: ".no-change",
            onUpdate: (evt) => {
              // 改变数组排序
              const temp = this.info.contentList[evt.oldIndex];
              this.info.contentList.splice(evt.oldIndex, 1);
              this.info.contentList.splice(evt.newIndex, 0, temp);
              // 重新按顺序渲染dom 确保视图和数据一致
              const arr = this.info.contentList.slice(0);
              this.info.contentList = [];
              this.$nextTick(() => {
                this.info.contentList = arr;
                this.updateVuex();
              });
            },
          });
        });
      },
      immediate: true,
      deep: true,
    },
    "$store.state.mDecoration.currentFloor": {
      handler(newValue) {
        if (newValue.id == 206 && this.floor.key == newValue.key) {
          // 获取轮播图数据
          this.info.contentList = JSON.parse(
            JSON.stringify(newValue.contentList)
          );
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},

  methods: {
    // 获得焦点时根据是否选择链接类型绑定事件
    visibleHandler(type, index) {
      // 获取所有的下拉列表中的元素
      const els = document.querySelectorAll(".el-select-dropdown__item");
      // 如果是展开下拉列表 则绑定事件
      if (els) {
        els.forEach((el) => {
          el.onclick = () => {
            // 显示对应的弹窗
            this.showDialog(type, index);
          };
        });
      }
      // 如果是收起下拉列表 则清除绑定的事件
      // if (!e) {
      // 等待dom更新之后再清除事件
      // this.$nextTick(() => {
      //   els.forEach((el) => {
      //     el.onclick = null;
      //   });
      // });
      // }
    },
    // 下拉框清除事件
    clearHandler(index) {
      // 清除对应的数据
      this.info.contentList[index].linkType = "";
      this.info.contentList[index].link = "";
      // 更新数据到vuex中
      this.updateVuex();
    },
    // 显示对应的弹窗
    showDialog(type, index) {
      if (!type) return;
      // 存储当前的快捷导航的index
      this.$store.commit("mDecoration/setCurrentContentIndex", index);
      // 显示对应的弹窗
      this.$store.commit("mDecoration/setDialogType", `link${type}`);
    },
    // 更新数据到vuex中
    updateVuex() {
      const list = JSON.parse(
        JSON.stringify(this.$store.state.mDecoration.floorList)
      );
      list[this.floor.index] = this.info;
      this.$store.commit("mDecoration/setFloorList", list);
      // 更新当前楼层信息
      this.$store.commit("mDecoration/setCurrentFloor", list[this.floor.index]);
    },
    // 添加快捷导航楼层的导航
    addNavContent() {
      // 最多添加8个
      if (this.info.contentList.length >= 8) {
        this.$message({
          message: "最多添加8个导航~",
          type: "warning",
        });
        return;
      }
      this.info.contentList.push({
        navName: "",
        navImg: "",
        link: "",
        linkType: "",
      });
      this.updateVuex();
    },
    // 删除导航
    delNav(index) {
      this.info.contentList.splice(index, 1);
      this.updateVuex();
    },
    // 导航图片点击上传
    navImgClick(index) {
      this.navImgIndex = index;
      // 上传前清空标签缓存
      this.$refs.navImg.value = "";
      this.$refs.navImg.click();
    },
    // 选择导航图片
    selectNavImg() {
      const file = this.$refs.navImg.files[0];
      if (!file) return;
      // 校验文件大小不超过10kb
      if (file.size > 10240) {
        this.$message({
          message: "图片大小不能超过10kb",
          type: "warning",
        });
        return;
      }
      // file转base64
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        this.$set(
          this.info.contentList[this.navImgIndex],
          "navImg",
          e.target.result
        );
        this.updateVuex();
      };
    },
    // 删除导航图片
    delNavImg(index) {
      this.$set(this.info.contentList[index], "navImg", "");
      this.updateVuex();
    },
    // 导链接失去焦点时 进行校验
    blurNavUrl(index) {
      let url = this.info.contentList[index].navUrl;
      // 如果没有输入链接 不进行校验
      if (!url || url.length == 0) return;
      // 校验链接是否正确
      const index1 = url.indexOf("https://");
      let index2 = url.indexOf(".com", index1 + 8);
      const mainUrl = url.slice(index1 + 8, index2);
      if (
        index1 == -1 ||
        index2 == -1 ||
        (mainUrl.indexOf("zxxk") == -1 && mainUrl.indexOf("xkw") == -1)
      ) {
        this.$message({
          message: "请输入学科网内链接~",
          type: "warning",
        });
        this.info.contentList[index].navUrl = "";
      }
      this.updateVuex();
    },
  },
};
</script>

<style lang="scss" scoped>
.aside-box {
  .floor-name,
  .floor-style {
    margin-bottom: 40px;
  }
  .info-name {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 20px;

    span {
      margin-right: 4px;
      font-size: 15px;
      font-weight: 600;
      color: #fe4509;
    }
    p {
      font-size: 15px;
      font-weight: 500;
      color: #606266;
    }
  }
  .info-content {
    padding-left: 12px;

    .info-content-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 24px;

      & > span {
        margin-right: 4px;
        font-size: 15px;
        font-weight: 600;
        color: #fe4509;
      }

      & > p {
        width: 80px;
        font-size: 12px;
        color: #606266;
      }
      & > div {
        width: 220px;
      }

      ::v-deep .el-radio-group.group-type2 .el-radio {
        margin-bottom: 20px;
      }
    }

    .info-content-item2 {
      transform: translateX(-12px);
    }

    .nav-list {
      .nav-li {
        width: 278px;
        height: 180px;
        padding: 15px 15px;
        margin-bottom: 20px;
        background: #ffffff;
        border: 1px dashed transparent;

        .nav-header {
          display: flex;
          align-items: center;
          justify-content: space-between;

          p {
            font-weight: 500;
            font-size: 13px;
            color: #606266;
          }

          .del-nav-icon {
            display: none;
            width: 11px;
            height: 12px;
            background: url(../../../assets/images/pc-decoration/del-floor-icon.png)
              no-repeat;
            background-size: 100% 100%;
            cursor: pointer;

            &:hover {
              background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
                no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        &:hover {
          border: 1px dashed #c0d0ff;
          box-shadow: 0px 0px 10px rgba(191, 191, 191, 0.25);
          border-radius: 5px;

          .del-nav-icon {
            display: block;
          }
        }
        .nav-body {
          margin-top: 15px;

          & > div {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            p {
              width: 70px;
              font-size: 12px;
              color: #606266;
              white-space: nowrap;
            }
          }
          .nav-name {
            margin-bottom: 15px;
            span {
              margin-left: -9px;
              margin-right: 4px;
              font-size: 12px;
              font-weight: 600;
              color: #fe4509;
            }
            .nav-name-input {
              width: 210px;
            }
          }

          .nav-img {
            margin-bottom: 15px;
            span {
              margin-left: -9px;
              margin-right: 4px;
              font-size: 12px;
              font-weight: 600;
              color: #fe4509;
            }
            .nav-img-box {
              position: relative;
              width: 30px;
              height: 30px;
              margin-right: 10px;
              border-radius: 5px;
              background-size: 100% 100%;
              transition: all 0.2s linear;

              .del-img-box {
                display: none;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 0px;
                right: 0px;
                left: 0px;
                bottom: 0px;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.4);
                border-radius: 5px;

                .del-img-icon {
                  width: 11px;
                  height: 12px;
                  background: url(../../../assets/images/pc-decoration/del-floor-icon3.png)
                    no-repeat;
                  background-size: 100% 100%;
                  cursor: pointer;

                  &:hover {
                    background: url(../../../assets/images/pc-decoration/del-floor-icon2.png)
                      no-repeat;
                    background-size: 100% 100%;
                  }
                }
              }

              &:hover {
                .del-img-box {
                  display: flex;
                }
              }
            }

            .add-img-box {
              width: 30px;
              height: 30px;
              margin-right: 10px;
              background: #ffffff;
              border: 1px dashed #a3baff;
              border-radius: 5px;
              font-size: 18px;
              text-align: center;
              line-height: 28px;
              font-weight: 500;
              color: #5a83ff;
              cursor: pointer;
            }
            .nav-img-tips {
              width: 175px;
              font-size: 12px;
              color: #c4c8d0;
            }
          }

          .nav-url {
            .nav-url-input {
              width: 210px;
            }
          }
        }
      }
    }

    .swiper-list {
      .swiper-li {
        .swiper-body {
          .swiper-img {
            .swiper-img-show {
              width: 210px;
              height: 40px;
              border-radius: 5px;
            }
            .create-swiper-btn {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 210px;
              height: 30px;
              background: #ffffff;
              border: 1px solid #a2baff;
              border-radius: 5px;
              cursor: pointer;

              .create-swiper-icon {
                width: 9px;
                height: 12px;
                margin-right: 5px;
              }

              p {
                font-size: 12px;
                color: #5a83ff;
              }
            }
          }
          .swiper-tips {
            margin-bottom: 15px;
            color: #c4c8d0;
          }
        }
      }
    }
    .show-shop-info {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      .shop-info-title {
        width: 70px;
        margin-right: 12px;
        font-size: 12px;
        color: #606266;

        span {
          font-weight: 600;
          font-size: 12px;
          color: #fe4509;
        }
      }
      .shop-info-list {
        width: 230px;
        overflow: hidden;

        .shop-info-li {
          float: left;
          width: 75px;
          margin-bottom: 10px;

          ::v-deep .el-checkbox__label {
            font-size: 12px;
            color: #606266;
          }
        }
      }
    }
    .info-origin {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 20px;
      .info-title {
        width: 70px;
        margin-right: 12px;
        font-size: 12px;
        color: #606266;

        span {
          font-weight: 600;
          font-size: 12px;
          color: #fe4509;
        }
      }
      ::v-deep .el-input--suffix .el-input__inner {
        width: 220px;
      }
      ::v-deep .el-scrollbar__wrap {
        overflow-x: auto !important;
      }
    }
    .info-order {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      .info-title {
        width: 70px;
        margin-right: 12px;
        font-size: 12px;
        color: #606266;

        span {
          font-weight: 600;
          font-size: 12px;
          color: #fe4509;
        }
      }

      ::v-deep .el-radio-group {
        width: 220px;

        .el-radio {
          margin-bottom: 20px;
        }
      }
    }
    .add-content-li {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 310px;
      height: 32px;
      margin-bottom: 30px;
      background: #ffffff;
      border: 1px dashed #5a83ff;
      border-radius: 5px;
      cursor: pointer;

      span {
        font-size: 20px;
        font-weight: 500;
        transform: translate(-2px, -2px);
        color: #5a83ff;
      }

      p {
        font-size: 14px;
        color: #5a83ff;
      }
      div {
        font-size: 12px;
        color: #c4c8d0;
      }

      .edit-icon {
        width: 9px;
        height: 12px;
        margin-right: 5px;
      }
    }
  }
  .nav-info-content {
    padding-bottom: 30px;
  }
}
</style>
